import { requireService } from 'src/packages/di';
import type { TDashboardReceivingMessage } from 'src/packages/session-service/SessionService';

import type { WorkspaceStore } from '../Workspace.store';

export class WorkspaceRefreshingService {
  private readonly workspace: WorkspaceStore;

  constructor(
    workspace: WorkspaceStore,
    private readonly sessionService = requireService('sessionService'),
  ) {
    this.workspace = workspace;
  }

  sendWorkspaceChanged(): void {
    this.sessionService.sendMessage('WORKSPACE-CHANGED');
  }

  private onWorkspaceChange = (message: TDashboardReceivingMessage): void => {
    if (message !== 'WORKSPACE-CHANGED') return;

    this.workspace.updateWorkspace();
  };

  init = (): void => {
    this.sessionService.subscribe(this.onWorkspaceChange);
  };

  dispose = (): void => {
    this.sessionService.unsubscribe(this.onWorkspaceChange);
  };
}
